import { Component, Input } from '@angular/core';
import { FieldBase } from '../field.base';
import { FormField } from '../../../../../../api/models/form-field';
import { UntypedFormGroup } from '@angular/forms';

@Component({
    selector: 'otb-numeric-select-field',
    templateUrl: './numeric-select-field.component.html',
    styleUrls: ['./numeric-select-field.component.scss'],
    standalone: false,
})
export class NumericSelectFieldComponent extends FieldBase {
    @Input() formField: FormField;
    @Input() form: UntypedFormGroup;
    @Input() formNumber: number = 0;
}
